var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{attrs:{"type":"primary","icon":"el-icon-download","size":"medium"},on:{"click":_vm.click}},[_vm._v("导出Excel详情")])}
var staticRenderFns = []

export { render, staticRenderFns }